// ENG-032: route-level role gate. Same `access` value as the sidebar item (platformNav.ts); without the role the
// page is replaced by a "no access" card inside the shell, never an empty page.
import React from "react";
import { Link } from "react-router-dom";
import { Spinner } from "@fluentui/react";
import { isAuthEnabled } from "../../authConfig";
import { useAuth } from "../../contexts/AuthContext";
import { Card } from "../../components/platform/Card";
import { PlatformAccess, canAccess } from "./platformNav";

const COPY = {
    checking: "Checking access...",
    title: "No access",
    admin: "This page is restricted to the Admin role.",
    observer: "This page needs the Analytics or Admin role.",
    back: "Back to chat",
    overview: "Admin overview"
};

export const NoAccess: React.FC<{ access: PlatformAccess }> = ({ access }) => (
    <Card title={COPY.title}>
        <p>{access === "admin" ? COPY.admin : COPY.observer}</p>
        <p>
            <Link to="/admin">{COPY.overview}</Link> · <Link to="/">{COPY.back}</Link>
        </p>
    </Card>
);

export const RequireAccess: React.FC<{ access: PlatformAccess; children: React.ReactNode }> = ({ access, children }) => {
    const { loading, hasRole } = useAuth();
    if (isAuthEnabled && loading) return <Spinner label={COPY.checking} />;
    if (!canAccess(access, hasRole)) return <NoAccess access={access} />;
    return <>{children}</>;
};
